import React from 'react';
import PropTypes from 'prop-types';
import Avatar from 'components/Avatar';
import MatchIcon from 'assets/images/connections/match_success.svg';
import Confetti from 'assets/images/gifs/confetti.gif';
import { GreetingsModal } from './styles';

function NewUserConnection(props) {
  const {
    user, actualUser, literals, onClose,
  } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <GreetingsModal>
      <img src={Confetti} alt='' className='confetti' />
      <div className='users'>
        <div>
          <Avatar id={user.id} avatar={user.avatar} firstname={user.firstname} size={80} />
        </div>
        <div>
          <Avatar id={actualUser.id} avatar={actualUser.avatar} firstname={actualUser.firstname} size={80} />
        </div>
      </div>
      <img src={MatchIcon} alt='' className='match_icon' />
      <div className='info'>
        <strong>{`${user.firstname} ${literals.wasAlsoLookingForwardsWithYou}`}</strong>
        {literals.youAreNowConnected}
      </div>
      <div className='buttons'>
        <button className='primary' onClick={handleClose}>{literals.close}</button>
      </div>
    </GreetingsModal>
  );
}

NewUserConnection.propTypes = {
  user: PropTypes.object.isRequired,
  actualUser: PropTypes.object.isRequired,
  literals: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default NewUserConnection;



// WEBPACK FOOTER //
// ./src/components/NotificationsTypes/NewUserConnection/components/index.jsx